import axios from "axios";
export const fetchUserEntryDetail = async (UserKey) => {
    try {
        const response = await axios.post(`/api/User/GetByKey`, { UserKey: UserKey });
        if (response && response.status === 200) {
            return response.data.data;
        } else {
            console.error("fetch User detail error.")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}

export const ChangeUserStatus = async (values, userStatus) => {
    try {
        var result = { Status: true, Message: "", Data: null };
        var data = {
            UserId: values,
            Active: userStatus,
        }
        // const response = await axios.post(`/api/User/ChangeUserStatus`, data);
        // const response = await axios.put(`/api/User/${data.UserKey}`, data);
        // const response = await axios.put(`/api/Common/UpdateUserStatus/${data.UserKey}`, data);
        const response = await axios.post(`/api/Common/UpdateUserStatus/`, data);
        if (response && response.status === 200) {
            return response.data;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
        else {
            result.Status = false;
            result.Message = "Unhandled exception";
            return result;
        }
    }
}

export const fetchUserEntryList = async (values, userId, saleperson, currentPage, rowPerPage, roleId, status, searchKeyword) => {
    try {
        var data = {
            CompanyId: values,
            UserId: userId,
            SalePersonId: saleperson,
            CurrentPage: currentPage,
            RowPerPage: rowPerPage,
            RoleNo: roleId,
            Active: status,
            SearchKeyword: searchKeyword,

        }
        const response = await axios.post(`/api/User/Search`, data);
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}


export const deleteUser = async (values) => {
    try {
        var result = { Status: true, Message: "", Data: null };
        var data = {
            userID: values.userId,
            // PhotosToDelete: values.userImages,
            // Timestamp: values.timestamp,
        }
        const response = await axios.post(`/api/User/Delete`, data);
        if (response && response.status === 200) {
            return response;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
        else {
            result.Status = false;
            result.Message = "Unhandled exception";
            return result;
        }
    }
}

export const saveUserEntry = async (values, companyId) => {
    var result = { Status: true, Message: "", Data: null };
    let profileImage = [values.profile.indexOf("static/") === -1 ? values.profile.split('base64,')[1] : values.profile];
    let data = "";
    let epinMSId = "";

    //for station
    if (values.role.value === 3) {
        if (values.salePersonUserId === null || values.salePersonUserId === undefined) {
            data = {
                UserId: values.userID,
                DisplayName: values.userName,
                PhoneNb: values.phNo,
                LoginId: values.loginId,
                RoleNo: values.role.value,
                Active: values.isActive,
                CheckPin: values.hasToCheckPwd,
                MasterSimNo: 0,
                Address: values.address,
                CompanyId: companyId,
                SalePersonId: 0,
                PaidType: values.paidType.value,
                PrePaidAmount: 0,
                CreditLimit: parseInt(values.creditLimit),
                CreditBalance: values.creditBalance,
            }
        } else {
            data = {
                UserId: values.userID,
                DisplayName: values.userName,
                PhoneNb: values.phNo,
                LoginId: values.loginId,
                RoleNo: values.role.value,
                Active: values.isActive,
                CheckPin: values.hasToCheckPwd,
                MasterSimNo: 0,
                Address: values.address,
                CompanyId: companyId,
                Password: values.password,
                ProfilePicture: profileImage.join(';'),
                ProfileToDelete: values.profileToDelete,
                SalePersonId: values.salePersonUserId.value,
                PaidType: values.paidType.value,
                PrePaidAmount: 0,
                CreditLimit: parseInt(values.creditLimit),
                CreditBalance: values.creditBalance,
            }
        }
    }
    //for Eload
    else if (values.role.value === 2) {
        if(values.epinMasterSim === null){
            epinMSId = 0
        }else if(values.epinMasterSim !== ""){
            epinMSId = values.epinMasterSim.value;
        }
        data = {
            UserId: values.userID,
            DisplayName: values.userName,
            Password: values.password,
            PhoneNb: values.phNo,
            LoginId: values.loginId,
            RoleNo: values.role.value,
            Active: values.isActive,
            CheckPin: values.hasToCheckPwd,
            MasterSimNo: values.masterSim.value,
            EpinMasterSimId: epinMSId,
            Address: values.address,
            CompanyId: companyId,
            SalePersonId: null,
            ProfilePicture: profileImage.join(';'),
            ProfileToDelete: values.profileToDelete,
            CreditLimit: 0,
            CreditBalance: 0,
        }
        //for Admin, Portal Admin , Sale Person Role , Account    
    } else if (values.role.value === 1 || values.role.value === 4 || values.role.value === 5) {
        data = {
            UserId: values.userID,
            DisplayName: values.userName,
            PhoneNb: values.phNo,
            Password: values.password,
            LoginId: values.loginId,
            RoleNo: values.role.value,
            Active: values.isActive,
            CheckPin: values.hasToCheckPwd,
            MasterSimNo: 0,
            Address: values.address,
            CompanyId: companyId,
            ProfilePicture: profileImage.join(';'),
            ProfileToDelete: values.profileToDelete,
            SalePersonId: null,
            CreditLimit: 0,
            CreditBalance: 0,
        }
    }else{
        data = {
            UserId: values.userID,
            DisplayName: values.userName,
            PhoneNb: values.phNo,
            Password: values.password,
            LoginId: values.loginId,
            RoleNo: values.role.value,
            Active: values.isActive,
            CheckPin: values.hasToCheckPwd,
            MasterSimNo: 0,
            Address: values.address,
            CompanyId: companyId,
            ProfilePicture: profileImage.join(';'),
            ProfileToDelete: values.profileToDelete,
            SalePersonId: null,
            CreditLimit: 0,
            CreditBalance: 0,
        }
    }
    if (values.userID === 0 || values.userID === null) {
        try {
            const response = await axios.post(`/api/User/CreateNewUser`, data);
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }

    } else {
        try {
            data.UserId = values.userID;
            const response = await axios.put(`/api/User/${data.UserId}`, data);
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    }
}

export const fetchUserbyRole = async (roleId, companyId, loginUserRoleId, userID) => {
    var data = {
        FilterWithRoleId: roleId.toString(),
        CompanyId: companyId.toString(),
        LoginUserRoleId: loginUserRoleId.toString(),
        userId: userID.toString(),
    }
    try {
        const response = await axios.post(`/api/User/GetUserListByRoleId`, data);
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("fetch user by role error.")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}